<template>
	<div class="warehouse-log">
		<div class="tablebox">
			<div class="filterdiv filterty" ref="filter">
				<el-form :inline="true" :model="formfilter" class="demo-form-inline" size="small" label-width="0"
					v-if="filtershow">
					<el-form-item label="">
						<el-select v-model="formfilter.type" placeholder="类型">
							<el-option label="全部" value=""></el-option>
							<el-option :label="v.name" :value="v.id" v-for="(v, k) in typeList" :key="v.id"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item>
						<el-button type="primary" @click="onfilter">查询</el-button>
						<el-button @click="onreset">重置</el-button>
					</el-form-item>
				</el-form>
			</div>
			<div class="zk" @click="filtershow = !filtershow">
				<span>{{ filtershow ? '收起' : '展开' }}</span>
			</div>
			<div class="tablediv" ref="tablediv">
				<el-table :data="list" style="width: 100%" border height="100%">
					<el-table-column prop="type_str" label="类型" align="center" header-align="center" min-width="110px">
					</el-table-column>
					<el-table-column label="变动金额" align="center" header-align="center" min-width="100px">
						<template slot-scope="scope">{{ fenToYuan(scope.row.amount) }}</template>
					</el-table-column>
					<el-table-column label="变动前保证金" align="center" header-align="center" min-width="110px">
						<template slot-scope="scope">{{ fenToYuan(scope.row.deposit_before) }}</template>
					</el-table-column>
					<el-table-column label="变动后保证金" align="center" header-align="center" min-width="110px">
						<template slot-scope="scope">{{ fenToYuan(scope.row.deposit_after) }}</template>
					</el-table-column>
					<el-table-column label="变动前冻结" align="center" header-align="center" min-width="100px">
						<template slot-scope="scope">{{ fenToYuan(scope.row.frozen_before) }}</template>
					</el-table-column>
					<el-table-column label="变动后冻结" align="center" header-align="center" min-width="100px">
						<template slot-scope="scope">{{ fenToYuan(scope.row.frozen_after) }}</template>
					</el-table-column>
					<el-table-column prop="related_id" label="关联单据" align="center" header-align="center" min-width="80px">
					</el-table-column>
					<el-table-column prop="remark" label="备注" align="center" header-align="center" min-width="140px">
					</el-table-column>
					<el-table-column prop="create_time_str" label="时间" align="center" header-align="center" width="160px">
					</el-table-column>
				</el-table>
			</div>
			<div class="pagediv">
				<el-pagination background layout="prev, pager, next, sizes, total" :page-sizes="[20, 30, 50, 100, 200]"
					:current-page.sync="page" :page-size="pageSize" :total="total" v-if="total > 0"
					@current-change="handleCurrentChange" @size-change="handleSizeChange">
				</el-pagination>
			</div>
		</div>
	</div>
</template>

<script>
	import { fenToYuan, apiMsg } from './money.js'

	export default {
		name: 'WarehouseDepositLog',
		data() {
			return {
				list: [],
				page: 1,
				pageSize: 20,
				total: 0,
				filtershow: true,
				formfilter: {
					type: ''
				},
				typeList: [
					{ id: 1, name: '充值' },
					{ id: 2, name: '入仓确认调整' },
					{ id: 3, name: '销售扣减' },
					{ id: 4, name: '退仓释放' },
					{ id: 5, name: '保证金退还' },
					{ id: 6, name: '即时变现扣减' },
					{ id: 7, name: '入仓预冻结' },
					{ id: 8, name: '调价释放' },
					{ id: 9, name: '盘点多出确认' },
					{ id: 10, name: '盘点短少赔付' }
				]
			}
		},
		mounted() {
			this.onlist()
			this.resizeObserver = new ResizeObserver(entries => {
				for (let entry of entries) {
					const cr = entry.contentRect
					var num = Number(cr.height) + 30
					this.$refs.tablediv.style.height = 'calc(100% - ' + num + 'px)'
				}
			})
			this.resizeObserver.observe(this.$refs.filter)
		},
		beforeDestroy() {
			if (this.resizeObserver) {
				this.resizeObserver.disconnect()
			}
		},
		methods: {
			fenToYuan: fenToYuan,
			handleCurrentChange() {
				this.onlist()
			},
			handleSizeChange(val) {
				this.page = 1
				this.pageSize = val
				this.onlist()
			},
			onfilter() {
				this.page = 1
				this.onlist()
			},
			onreset() {
				this.formfilter = {
					type: ''
				}
				this.page = 1
				this.onlist()
			},
			onlist() {
				var params = {
					page: this.page,
					limit: this.pageSize
				}
				if (this.formfilter.type !== '' && this.formfilter.type !== null && this.formfilter.type !== undefined) {
					params.type = this.formfilter.type
				}
				this.$axios.get('api/cloud_warehouse/deposit_log', { params: params }).then(res => {
					if (res.data.code === 0) {
						var data = res.data.data || {}
						this.total = data.count || 0
						this.list = data.list || []
					} else {
						this.$message.error(apiMsg(res))
					}
				}).catch(err => {
					console.log(err)
				})
			}
		}
	}
</script>

<style scoped lang="less">
	.warehouse-log {
		height: 100%;
	}

	.tablebox {
		height: 100%;
	}
</style>



// WEBPACK FOOTER //
// src/components/buyer/warehouse/depositLog.vue